export default __webpack_public_path__ + "static/media/icon-pin.66901d64.svg";